<template>
  <div class="expenseNameManagementDetail">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <van-field
        v-model="form.ItemName"
        :label="$t.expenseNameManagement.paymentProject"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.ItemNameEn"
        :label="$t.expenseNameManagement.paymentProjectEn"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "expenseNameManagementDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isEdit: false,
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
    };
  },
  created() {
    const { IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      var data = JSON.parse(localStorage.getItem("expenseNameManagementDetail"));
      this.form = data;
    } else {
      this.form = {
        ItemName: "",
        ItemNameEn: "",
      };
    }
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.isEdit) {
        request = this.$api.financialManagement.editBillPayment(param);
      } else {
        request = this.$api.financialManagement.addBillPayment(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.expenseNameManagementDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
}
</style>
